import React, { Component } from 'react'

import './Checkbox.css';

class Checkbox extends Component {
  constructor(props){
    super(props);

    this.state = {
      value: props.value,
      onToggle: props.onToggle 
    }
  }

  componentWillReceiveProps(newProps){
    this.setState({
      value: newProps.value,
      onToggle: newProps.onToggle,
      disabled: newProps.disabled
    })
  }

  render(){    
    return this.state.value ? 
    (
      <span className={"checkbox checkbox-true " + (this.state.disabled ? "checkbox-disabled" : "") + ( this.props.switch ? " checkbox-switch" : "")} key={'true-check'} onClick={()=>{ this.state.onToggle(!this.state.value)}}>
        <i className={"fas fa-fw "  + ( this.props.switch ? "fa-toggle-on" : "fa-check-square") + (this.props.large ? " fa-lg" : "")}></i>
      </span>
    ) :
    (
      <span className={"checkbox checkbox-false " + (this.state.disabled ? "checkbox-disabled" : "") + ( this.props.switch ? " checkbox-switch" : "")} key={'false-check'} onClick={()=>{ this.state.onToggle(!this.state.value)}}>
        <i className={"fas fa-rotate-180 fa-fw "  + ( this.props.switch ? "fa-toggle-on" : "fa-square") + (this.props.large ? " fa-lg" : "") }></i>
      </span>
    )
  }
};

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.js